import { connect } from "react-redux";
import { compose } from "redux";
import { withUser, withUserData, persistTimezone } from "../../store/user";
import { withTimestamp } from "../../store/timestamp";
// import { TRACK_EDIT_TIMEZONE, callOnlyOnce } from "../../store/mixpanel";

export default compose(
  withUser,
  withUserData,
  withTimestamp,
  connect(
    ({}) => ({}),
    dispatch => ({
      saveTimezone(timezone) {
        dispatch(persistTimezone({ timezone, from: "modal" }));
      }
    })
  )
);



// WEBPACK FOOTER //
// ./src/components/ZoneSelect/connector.js